import {
  GET_PDF_DOWNLOAD_REQUEST,
  GET_PDF_DOWNLOAD_SUCCESS,
  GET_PDF_DOWNLOAD_ERROR
  } from "../actions/types";

  export default function (state = [], action) {
    const { type, payload } = action;
    switch (type) {
      case GET_PDF_DOWNLOAD_REQUEST:
        return {
          loading: true,
        };
      case GET_PDF_DOWNLOAD_SUCCESS:
        return {
          ...state,
          loading: false,
          payload,
        };
      case GET_PDF_DOWNLOAD_ERROR:
        return {
          ...state,
          loading: false,
        };
      default:
        return state;
    }
  }
  